<div class="row" *ngIf="customer != null && customer.customerName != null">
    <div class="wrapper col-sm-12">
        <kendo-expansionpanel [title]="'Customer Status: ' + getCustomerStatusDisplay()"
                              [subtitle]="''"
                              [disabled]="false"
                              [expanded]="true">
            <ng-template kendoExpansionPanelTitleDirective>
                <div class="header-content">
                    <span>
                        Customer Status: {{getCustomerStatusDisplay()}}
                    </span>
                    <span>
                        <input type="checkbox" style="margin:0 5px 0 20px;transform:scale(1.5)" [(ngModel)]="isShowLeadStatusType" [checked]="isShowLeadStatusType" *ngIf="customerStatus.statusType != 'Lead'" />
                        Show Lead Stages
                    </span>
                </div>
            </ng-template>
            <customer-status-checklist-form [customerID]="customer.customerID"
                                            [customerStatusID]="customer.customerStatusID"
                                            [isShowLeadStatusType]="isShowLeadStatusType"
                                            (onRefresh)="searchCustomer()">
            </customer-status-checklist-form>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="customer.customerName"
                              [subtitle]="customer.address1 + ',' + customer.cityStateZip"
                              [expanded]="this.divFlags['customerForm']">
            <kendo-tabstrip (tabSelect)="onTabSelect($event)">
                <kendo-tabstrip-tab title="Profile" [selected]="true">
                    <ng-template kendoTabContent>
                        <div style="padding-right:15px;">
                            <customer-form [customerID]="customer.customerID" [pageType]="'Customer Profile'" (customerSaved)="customerSaved($event)"></customer-form>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Assigned Employees">
                    <ng-template kendoTabContent>
                        <div class="content col-sm-6">
                            <customer-team-assigned [customerID]="customer.customerID" [pageType]="'customer detail'"></customer-team-assigned>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Tags">
                    <ng-template kendoTabContent>
                        <div class="content col-sm-6">
                            <tagmap-select [recordID]="customer.customerID"
                                           [recordTypeName]="'Customer'"
                                           (onRefresh)="refreshData('tags')">
                            </tagmap-select>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Child Companies" *ngIf="customer.parent == 'Y'">
                    <ng-template kendoTabContent>
                        <customer-child-grid [parentCustomerID]="customer.customerID"
                                             (onRefresh)="refreshData('childCustomers')">
                        </customer-child-grid>
                    </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Audit History">
                    <ng-template kendoTabContent>
                        <div class="content col-sm-12">
                            <customer-history-grid [customerID]="customer.customerID"></customer-history-grid>
                        </div>
                    </ng-template>
                </kendo-tabstrip-tab>
            </kendo-tabstrip>
        </kendo-expansionpanel>
        <customer-opportunity-grid [customerID]="customer.customerID" [customerCode]="customer.customerCode"></customer-opportunity-grid>
        <kendo-expansionpanel [title]="'Contacts'"
                              [subtitle]="'Total: ' + contacts.length"
                              [expanded]="true">
            <contact-grid [contactType]="'Customer'" [tableID]="customer.customerID" [countryCode]="customer.countryAbbrev"></contact-grid>
        </kendo-expansionpanel>
        <customer-action-grid [customerID]="customer.customerID" (customerActionSaved)="searchCustomer()"></customer-action-grid>
        <kendo-expansionpanel [title]="'Quote/Order History'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="row">
                <div class="col-lg-12">
                    <button type="button" class="btn btn-primary" (click)="includeParent = false; getCustomerHistory();">View History</button>
                    <button type="button" class="btn btn-primary" (click)="includeParent = true; getCustomerHistory();">View History by Parent</button>
                    <kendo-tabstrip>
                        <kendo-tabstrip-tab [title]="'Orders'" [selected]="true">
                            <ng-template kendoTabContent>
                                <kendo-grid [data]="billToView"
                                            [pageSize]="billToState.take"
                                            [skip]="billToState.skip"
                                            [sort]="billToState.sort"
                                            [filter]="billToState.filter"
                                            [sortable]="true"
                                            [pageable]="true"
                                            [filterable]="true"
                                            (dataStateChange)="billToStateChange($event)">
                                    <kendo-grid-column field="orderNumber" title="Order #">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <!--<a (click)="openOrderLookup(dataItem.quoteOrderID)">{{dataItem.orderNumber}}</a>-->
                                            <a target="_blank" [routerLink]="['/order-entry', dataItem.quoteOrderID]">{{dataItem.orderNumber}}</a>
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="orderStatus" title="Status"></kendo-grid-column>
                                    <kendo-grid-column field="billDate" title="Bill Dt">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.billDate | date: 'M/dd/yyyy'}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="gross" title="Gross">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.gross | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="pay" title="Pay">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.pay | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="net" title="Net">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.net | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="origin" title="Origin"></kendo-grid-column>
                                    <kendo-grid-column field="destination" title="Destination"></kendo-grid-column>
                                    <kendo-grid-column field="shipper" title="Shipper"></kendo-grid-column>
                                    <kendo-grid-column field="consignee" title="Consignee"></kendo-grid-column>
                                    <kendo-grid-column field="tripType" title="Trip Type"></kendo-grid-column>
                                    <kendo-grid-column field="trailer" title="Trailer"></kendo-grid-column>
                                </kendo-grid>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab [title]="'Stops'">
                            <ng-template kendoTabContent>
                                <kendo-grid [data]="stopsView"
                                            [pageSize]="stopsState.take"
                                            [skip]="stopsState.skip"
                                            [sort]="stopsState.sort"
                                            [filter]="stopsState.filter"
                                            [sortable]="true"
                                            [pageable]="true"
                                            [filterable]="true"
                                            (dataStateChange)="stopsStateChange($event)">
                                    <kendo-grid-column field="billTo" title="Bill To"></kendo-grid-column>
                                    <kendo-grid-column field="orderNumber" title="Order #">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <!--<a (click)="openOrderLookup(dataItem.orderNumber)">{{dataItem.orderNumber}}</a>-->
                                            <a target="_blank" [routerLink]="['/order-entry', dataItem.quoteOrderID]">{{dataItem.orderNumber}}</a>
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="orderStatus" title="Status"></kendo-grid-column>
                                    <kendo-grid-column field="billDate" title="Bill Dt">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.billDate | date: 'M/dd/yyyy'}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="gross" title="Gross">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.gross | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="pay" title="Pay">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.pay | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="net" title="Net">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.net | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="origin" title="Origin"></kendo-grid-column>
                                    <kendo-grid-column field="destination" title="Destination"></kendo-grid-column>
                                    <kendo-grid-column field="shipper" title="Shipper"></kendo-grid-column>
                                    <kendo-grid-column field="consignee" title="Consignee"></kendo-grid-column>
                                </kendo-grid>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab [title]="'Quotes'">
                            <ng-template kendoTabContent>
                                <kendo-grid [data]="quotesView"
                                            [pageSize]="quotesState.take"
                                            [skip]="quotesState.skip"
                                            [sort]="quotesState.sort"
                                            [filter]="quotesState.filter"
                                            [sortable]="true"
                                            [pageable]="true"
                                            [filterable]="true"
                                            (dataStateChange)="quotesStateChange($event)">
                                    <kendo-grid-column field="orderNumber" title="Order #"></kendo-grid-column>
                                    <kendo-grid-column field="orderStatus" title="Status"></kendo-grid-column>
                                    <kendo-grid-column field="billDate" title="Bill Dt">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.billDate | date: 'M/dd/yyyy'}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="gross" title="Gross">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.gross | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="pay" title="Pay">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.pay | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="net" title="Net">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{dataItem.net | currency}}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="origin" title="Origin"></kendo-grid-column>
                                    <kendo-grid-column field="destination" title="Destination"></kendo-grid-column>
                                    <kendo-grid-column field="trailer" title="Trailer"></kendo-grid-column>
                                </kendo-grid>
                            </ng-template>
                        </kendo-tabstrip-tab>
                    </kendo-tabstrip>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
